export default defineNuxtPlugin(() => {
  // Плагин для улучшения доступности
  if (process.client) {
    // Добавляем ARIA атрибуты для элементов без имен
    const addAriaLabels = () => {
      // Кнопки без текста
      const buttons = document.querySelectorAll('button:not([aria-label]):not([aria-labelledby])')
      buttons.forEach((button, index) => {
        if (!button.textContent?.trim()) {
          button.setAttribute('aria-label', `Button ${index + 1}`)
        }
      })
      
      // Ссылки без текста
      const links = document.querySelectorAll('a:not([aria-label]):not([aria-labelledby])')
      links.forEach((link, index) => {
        if (!link.textContent?.trim()) {
          link.setAttribute('aria-label', `Link ${index + 1}`)
        }
      })
      
      // Элементы меню
      const menuItems = document.querySelectorAll('[role="menuitem"]:not([aria-label]):not([aria-labelledby])')
      menuItems.forEach((item, index) => {
        if (!item.textContent?.trim()) {
          item.setAttribute('aria-label', `Menu item ${index + 1}`)
        }
      })
      
      // Tooltip элементы - КРИТИЧЕСКАЯ ПРОБЛЕМА
      const tooltipTriggers = document.querySelectorAll('.ui-tooltip_trigger:not([aria-label]):not([aria-labelledby])')
      tooltipTriggers.forEach((trigger, index) => {
        // Пытаемся найти текст tooltip
        const tooltipText = trigger.getAttribute('data-tooltip') || 
                           trigger.getAttribute('title') || 
                           trigger.getAttribute('aria-describedby') ||
                           `Tooltip ${index + 1}`
        
        trigger.setAttribute('aria-label', tooltipText)
        trigger.setAttribute('role', 'button')
        trigger.setAttribute('tabindex', '0')
        
        // Убираем title чтобы избежать дублирования
        if (trigger.hasAttribute('title')) {
          trigger.removeAttribute('title')
        }
      })
    }
    
    // Запускаем при загрузке
    addAriaLabels()
    
    // Запускаем при изменениях DOM
    const observer = new MutationObserver(() => {
      addAriaLabels()
    })
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
    
    // Исправляем tabindex > 0
    const fixTabIndex = () => {
      const elementsWithTabIndex = document.querySelectorAll('[tabindex]')
      elementsWithTabIndex.forEach(element => {
        const tabIndex = parseInt(element.getAttribute('tabindex') || '0')
        if (tabIndex > 0) {
          element.setAttribute('tabindex', '0')
        }
      })
    }
    
    fixTabIndex()
    
    // Запускаем при изменениях DOM
    const tabIndexObserver = new MutationObserver(() => {
      fixTabIndex()
    })
    
    tabIndexObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['tabindex']
    })
  }
})
